export const PLAN_CODES = ["starter", "growth", "scale"] as const;
export type PlanCode = (typeof PLAN_CODES)[number];

export type PlanDefinition = {
  code: PlanCode;
  monthlyPriceUsd: number;
  checksPerMonth: number;
  extractionsPerMonth: number;
  generatedInvoicesPerMonth: number;
  members: number;
  historyDays: number;
  highlight: "base" | "growth" | "premium";
};

export const PLAN_CATALOG: Record<PlanCode, PlanDefinition> = {
  starter: {
    code: "starter",
    monthlyPriceUsd: 0,
    checksPerMonth: 20,
    extractionsPerMonth: 8,
    generatedInvoicesPerMonth: 10,
    members: 1,
    historyDays: 14,
    highlight: "base"
  },
  growth: {
    code: "growth",
    monthlyPriceUsd: 39,
    checksPerMonth: 300,
    extractionsPerMonth: 120,
    generatedInvoicesPerMonth: 150,
    members: 3,
    historyDays: 90,
    highlight: "growth"
  },
  scale: {
    code: "scale",
    monthlyPriceUsd: 149,
    checksPerMonth: 3000,
    extractionsPerMonth: 1200,
    generatedInvoicesPerMonth: 1500,
    members: 15,
    historyDays: 365,
    highlight: "premium"
  }
};

export const PLAN_LIST = PLAN_CODES.map((code) => PLAN_CATALOG[code]);

export const BILLING_PROVIDER = "paddle";
export const BILLING_INTERVALS = ["monthly"] as const;
export type BillingInterval = (typeof BILLING_INTERVALS)[number];

export const PAID_PLAN_CODES = PLAN_CODES.filter((code) => PLAN_CATALOG[code].monthlyPriceUsd > 0);

export const isPlanCode = (value: unknown): value is PlanCode =>
  typeof value === "string" && PLAN_CODES.includes(value as PlanCode);

export const isPaidPlanCode = (value: unknown): value is PlanCode =>
  isPlanCode(value) && PLAN_CATALOG[value].monthlyPriceUsd > 0;
